import { render, staticRenderFns } from "./deny-widget.vue?vue&type=template&id=27a26138&"
import script from "./deny-widget.vue?vue&type=script&lang=js&"
export * from "./deny-widget.vue?vue&type=script&lang=js&"
import style0 from "./deny-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports